import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'app-custom-forms-history-details-dialog',
  templateUrl: './custom-forms-history-details-dialog.component.html',
  styleUrls: ['./custom-forms-history-details-dialog.component.scss']
})
export class CustomFormsHistoryDetailsDialogComponent implements OnInit {
  displayColumns = ['modified_by_displayName', 'modified_at', 'actions'];
  title = '';
  formTitle = '';
  constructor(public router: Router,
              public dialogRef: MatDialogRef<CustomFormsHistoryDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = `Ιστορικό αλλαγών δηλώσεων για το μαθητή/μαθήτρια ${data.displayForms[0].displayName}`;
    this.formTitle = `${data.displayForms[0].title}`;
  }

  ngOnInit(): void {
  }

  async displayForm(form) {
    const inputConfig = {
      edit: false,
      childId: form.child_id,
      mode: true,
      parentId: form.notification_to_parent,
      unique_id: form.form_unique_id,
      id: form.id
    };
    await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
